import React from "react";

export const CloseIcon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M542 512l113 113c8 8 8 22 0 30-5 4-10 6-15 6-6 0-11-2-16-6L512 542 399 655c-5 4-10 6-15 6-6 0-11-2-16-6-8-8-8-22 0-30l113-113-113-113c-8-8-8-22 0-30 9-8 22-8 31 0l113 112 112-112c9-8 22-8 31 0 8 8 8 22 0 30z"/></svg>;
